export default __webpack_public_path__ + "static/media/left-arrow.defb2d2b.svg";